export const ACTIVITY_STATUS_POS_CODES_JA: Record<ACTIVITY_STATUS_POS_NUM, string> = {
  8: '動いている(立・座)',
  7: '動いている(寝)',
  6: '右側臥位',
  5: '左側臥位',
  4: 'うつ伏せ',
  3: '仰臥位',
  2: '上下逆',
  1: '座位',
  0: '立位',
} as const;

export const ACTIVITY_STATUS_POS_CODES_EN: Record<ACTIVITY_STATUS_POS_NUM, string> = {
  8: 'Moving (standing/sitting)',
  7: 'Moving (while lying in bed)',
  6: 'Right lateral position',
  5: 'Left lateral position',
  4: 'Face down position',
  3: 'Supine position',
  2: 'Upside down',
  1: 'Sitting',
  0: 'Standing',
} as const;

export type ACTIVITY_STATUS_POS_NUM = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

interface PostureInfo {
  id: number;
  name: string;
  nameKey: string;
  iconPath: string;
}

export const POSTURES: { u2: PostureInfo[]; u2p: PostureInfo[] } = {
  // U2用の姿勢定義
  u2: [
    {
      id: 0,
      name: '-',
      nameKey: '-',
      iconPath: '/images/residents/posture/none.svg',
    },
    { id: 1, name: '仰臥位', nameKey: 'SupinePosition', iconPath: '/images/residents/posture/supine.svg' },
    { id: 2, name: 'うつ伏せ', nameKey: 'PronePosition', iconPath: '/images/residents/posture/face-down.svg' },
    {
      id: 3,
      name: '右側臥位',
      nameKey: 'RightSupinePosition',
      iconPath: '/images/residents/posture/right-lateral.svg',
    },
    {
      id: 4,
      name: '左側臥位',
      nameKey: 'LeftSupinePosition',
      iconPath: '/images/residents/posture/left-lateral.svg',
    },
    {
      id: 5,
      name: '立位＆座位',
      nameKey: 'StandingAndSitting',
      iconPath: '/images/residents/posture/standing-and-sitting.svg',
    },
    { id: 6, name: '上下逆', nameKey: 'UpsideDown', iconPath: '/images/residents/posture/upside-down.svg' },
  ],
  // U2P用の姿勢定義
  u2p: [
    {
      id: 0,
      name: '立位＆座位',
      nameKey: 'StandingAndSitting',
      iconPath: '/images/residents/posture/standing-and-sitting.svg',
    },
    {
      id: 1,
      name: '立位＆座位',
      nameKey: 'StandingAndSitting',
      iconPath: '/images/residents/posture/standing-and-sitting.svg',
    },
    { id: 2, name: '上下逆', nameKey: 'UpsideDown', iconPath: '/images/residents/posture/upside-down.svg' },
    { id: 3, name: '仰臥位', nameKey: 'SupinePosition', iconPath: '/images/residents/posture/supine.svg' },
    { id: 4, name: 'うつ伏せ', nameKey: 'PronePosition', iconPath: '/images/residents/posture/face-down.svg' },
    {
      id: 5,
      name: '左側臥位',
      nameKey: 'LeftSupinePosition',
      iconPath: '/images/residents/posture/left-lateral.svg',
    },
    {
      id: 6,
      name: '右側臥位',
      nameKey: 'RightSupinePosition',
      iconPath: '/images/residents/posture/right-lateral.svg',
    },
  ],
};
